import { createContext } from '@direct-frontend/modules-context';

export interface FormsContext {
    /**
     * Флаг, нужно ли сохранять подписки на формы при анмаунте форм
     */
    shouldSaveSubscriptions?: boolean;
}

export type FormsContextInput = FormsContext;

const defaultValue: FormsContext = {
    shouldSaveSubscriptions: false,
};

export const {
    getContext: getFormsContext,
    setContext,
    isContextInitialized: isFormsContextInitialized,
} = createContext<FormsContext>({
    name: '@adv-frontend/form-kit',
    getInitialValue() {
        return defaultValue;
    },
});

export function setFormsContext(context: FormsContextInput) {
    setContext(context);
}
